export type BookingStatusValue =
  | "draft"
  | "pending"
  | "validated"
  | "refused"
  | "finished"
  | "canceled";

export type BookingStatus = {
  value: BookingStatusValue;
  label: string;
};

type BookingStatusStyle = {
  value: BookingStatusValue;
  color: string;
  backgroundColor: string;
  textColor: string;
};

const status: BookingStatusStyle[] = [
  { value: "draft", color: "#CBD5E1", backgroundColor: "#F1F5F9", textColor: "#000000" },
  { value: "pending", color: "#FACC15", backgroundColor: "#FEF9C3", textColor: "#000000" },
  { value: "validated", color: "#4ADE80", backgroundColor: "#BBF7D0", textColor: "#000000" },
  { value: "refused", color: "#F87171", backgroundColor: "#FECACA", textColor: "#000000" },
  { value: "finished", color: "#9CA3AF", backgroundColor: "#F3F4F6", textColor: "#000000" },
  { value: "canceled", color: "#F87171", backgroundColor: "#FECACA", textColor: "#000000" },
];

const resolveValue = (input: BookingStatusValue | BookingStatus): BookingStatusValue =>
  typeof input === "string" ? input : input.value;

const getColor = (input: BookingStatusValue | BookingStatus): string | null =>
  status.find((item) => item.value === resolveValue(input))?.color ?? null;

const getBackgroundColor = (input: BookingStatusValue | BookingStatus): string | null =>
  status.find((item) => item.value === resolveValue(input))?.backgroundColor ?? null;

const getTextColor = (input: BookingStatusValue | BookingStatus): string | null =>
  status.find((item) => item.value === resolveValue(input))?.textColor ?? null;

export {
  status,
  getColor,
  getBackgroundColor,
  getTextColor,
};
